import { API } from '../config/config';

const RaffleService = {
  generate: (config) => generate(config),
  getLotes: () => getLotes(),
  getRaffleLotes: () => getLotes(),
  getLote: (lote, params) => getLote(lote, params),
  setActivo: (lote, activo) => setActivo(lote, activo),
  getNext: (lote) => getNext(lote),
  getNextRaffleNumber: (lote) => getNext(lote),
  getAvailability: (lote, numero) => getAvailability(lote, numero),
  getRaffleAvailability: (lote, numero) => getAvailability(lote, numero),
  createStandaloneRaffleSale: (storeId, payload) => createStandaloneRaffleSale(storeId, payload),
  downloadPdf: (lote, overrides) => downloadPdf(lote, overrides),
  getDashboard: (lote) => getDashboard(lote),
  searchNumbers: (q, lote) => searchNumbers(q, lote),
};

const generate = async ({ nombre_negocio, texto_evento, premio, monto_minimo, cantidad, lote } = {}) => {
  const body = {};
  if (lote)           body.lote           = Number(lote);        // extend existing
  if (nombre_negocio) body.nombre_negocio = nombre_negocio;
  if (texto_evento)   body.texto_evento   = texto_evento;
  if (premio)         body.premio         = premio;
  if (monto_minimo)   body.monto_minimo   = Number(monto_minimo);
  if (cantidad)       body.cantidad       = Number(cantidad);
  const response = await API.post('/raffle/generate', body);
  return response.data;
};

const getLotes = async () => {
  const response = await API.get('/raffle/lotes');
  return response.data;
};

const getLote = async (lote, { page = 1, limit = 50 } = {}) => {
  const response = await API.get(`/raffle/lotes/${lote}?page=${page}&limit=${limit}`);
  return response.data;
};

const setActivo = async (lote, activo) => {
  const response = await API.patch(`/raffle/lotes/${lote}/activo`, { activo });
  return response.data;
};

const getNext = async (lote) => {
  const url = lote ? `/raffle/next?lote=${lote}` : '/raffle/next';
  const response = await API.get(url);
  return response.data;
};

const getAvailability = async (lote, numero) => {
  const params = new URLSearchParams({
    lote: String(lote),
    numero: String(numero),
  });
  const response = await API.get(`/raffle/availability?${params.toString()}`);
  return response.data;
};

const createStandaloneRaffleSale = async (storeId, payload) => {
  const response = await API.post(`/stores/${storeId}/raffle/sales`, payload);
  return response.data;
};

const downloadPdf = async (lote, { nombre, evento, premio } = {}) => {
  const params = new URLSearchParams({ lote });
  if (nombre) params.append('nombre', nombre);
  if (evento) params.append('evento', evento);
  if (premio) params.append('premio', premio);
  const response = await API.get(`/raffle/pdf?${params.toString()}`, { responseType: 'blob' });
  return response;
};

const getDashboard = async (lote) => {
  const url = lote ? `/raffle/dashboard?lote=${lote}` : '/raffle/dashboard';
  const response = await API.get(url);
  return response.data;
};

const searchNumbers = async (q, lote) => {
  const params = new URLSearchParams({ q });
  if (lote) params.append('lote', lote);
  const response = await API.get(`/raffle/numbers?${params.toString()}`);
  return response.data;
};

export default RaffleService;
